export const changeColorMatchesBtn = () => {
  const x = document.getElementById("peopleBtnId")!;
  x.style.backgroundColor = "#8EB5B9";
  const y = document.getElementById("matchesBtnId")!;
  y.style.backgroundColor = "#00BFD8";
  const z = document.getElementById("chartBtnId")!;
  z.style.backgroundColor = "#8EB5B9";
};
